// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"styles__checkboxWrapper___WK-xl","checkboxLabel":"styles__checkboxLabel___8ptyp"};